import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/houzz': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M275.9 330.7h-104.6v149.3h-154.3v-448h109.5v104.5l305.1 85.6v257.9h-155.7v-149.3z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/houzz.js
// module id = 882
// module chunks = 0